module.exports = __webpack_public_path__ + "static/media/Soybean9R3.d2f61b8a.PNG";